import {
    convertCategory,
    isHasProcedureBelongToCategory,
} from '../../modules/actions/categoryActions';
import { addonListeners } from '../../modules/events/addonListeners';
import { procedureListeners } from '../../modules/events/procedureListeners';
import { categories, isBookAppointment, surgicalOption, primaryColor, bodyAreaSelected, showBodyAreaSelection, isHideServiceDuration, form } from '../../utils/variables';
import { loadAddons } from './addons';
import { loadProcedureInformation } from './procedureInfomation';

export function loadProcedures(procedures) {
    const procedureContainer = document.querySelector('.procedures__container');
    procedureContainer.innerHTML = '';
    let categoriesList = [];
    const listCategory = bodyAreaSelected?.map(item => item.name);

    categoriesList = categories.filter((i) => {
        if (showBodyAreaSelection && !listCategory.includes(i.name)) {
            return false;
        }
        return isHasProcedureBelongToCategory(i, procedures)
    }
    );

    if (categoriesList.length <= 0) {
        procedureContainer.insertAdjacentHTML(
            'beforeend',
            `
        <div class="noProcedures">No Procedures Found</div>
        `
        );
        return;
    }
    for (const i of categoriesList) {
        procedureContainer.insertAdjacentHTML(
            'beforeend',
            `
        <div id="${convertCategory(
                i.name
            )}" class="procedure-section__container">
            <div class="category-section__wrapper">
                ${i.icon ?
                `
                    <img loading="lazy" class="category__icon" src="${process.env.GOOGLE_CLOUD_ICON_URL
                }${i.icon}"> 
                    `
                : ''
            }
                <span class="category__text">${i.name}</span>
            </div>
        </div>
        `
        );

        let proceduresList = procedures.filter((item) => {
            return item.service_categories
                ?.map((ca) => ca.name)
                .includes(i.name);
        });

        const procedureSectionContainer = document.querySelector(
            `[id='${convertCategory(
                i.name
            )}'][class='procedure-section__container']`
        );

        if (categoriesList.indexOf(i) === categoriesList.length - 1) {
            procedureSectionContainer.classList.add(
                'procedure-section__fake-height'
            );
        }

        if (proceduresList.length > 0) {
            procedureSectionContainer.insertAdjacentHTML(
                'beforeend',
                `
            <div class="procedures-list">${showListProcedure(
                    proceduresList,
                    i.name
                )}</div>
            `
            );
        } else {
            procedureSectionContainer.insertAdjacentHTML(
                'beforeend',
                `
            <div class="no-procedure-text">No procedures found</div>
            `
            );
        }
    }
    loadCheckBoxDetails(procedures);
    procedureListeners();
    addonListeners();

    document.querySelectorAll('.procedure__price').forEach(item => {
        item.style.backgroundColor = `${primaryColor}0f`;
    });
}

function showListProcedure(procedureList, category) {
    let listProcedures = ``;
    const isHideServicePricing = typeof surgicalOption === 'boolean' && !surgicalOption;
    for (const procedure of procedureList) {
        const isHideServiceDurationOption =
            isHideServiceDuration ||
            procedure?.hide_duration_on_select_service ||
            form?.appointment_channel?.hide_duration_on_select_service;
        const price = procedure?.from || 0;
        const isShowFormText = (procedure.force_addon_selection === 1) ? true : false;
        const filterAddOns = procedure?.procedure_addons?.filter(item => !item?.deleted_at);

        let procedureWrapper = `
        <div class="procedure__content">
            <div class="line__wrapper procedure" data-procedure-id="${procedure.id}" data-category="${category}">
                <div class="procedure__checkbox" data-procedure-id="${procedure.id}" data-category="${category}">
                    <i class="procedure__icon-check ri-check-line"></i>
                </div>
                <div class="procedure__name--wrapper">
                    <div class="procedure__info-wrapper">
                        <div class="procedure__name-duration">
                            <div class="procedure__name">${procedure.name}</div>
                            <div class="procedure__price-duration ${(surgicalOption || isHideServiceDurationOption) ? 'hidden' : ''}">${procedureDuration(procedure.duration)}</div>
                        </div>
                        <div class="procedure__price--wrapper ${isBookAppointment && price !== 0 && isHideServicePricing ? '' : 'hidden'}">
                            ${isShowFormText ? '<span>From</span>' : ''}
                            <div class="procedure__price">$${price.toLocaleString('en-US', { maximumFractionDigits: 2 })}</div>
                        </div> 
                    </div>
                    <div class="procedure__disableText"></div>
                </div>
                ${procedure.description
                ? `<span class="procedure__information procedure" data-procedure-id="${procedure.id}">
                        <i class="ri-question-line"></i>
                    </span>`
                : ""
            }
            </div>
            <div class="procedureBody__wrapper" data-procedure-id="${procedure.id
            }">
                ${loadProcedureInformation(procedure, category)}
            </div>
            <div class="addonsSections__wrapper addon__container" data-procedure-id="${procedure.id
            }" data-category="${category}">
                ${filterAddOns?.length > 0 ? loadAddons(procedure.id, category) : ''}
            </div>
        </div>
        `;

        listProcedures = listProcedures.concat(procedureWrapper);
    }

    return listProcedures;
}

function loadCheckBoxDetails(procedures) {
    let checkBox = document.querySelectorAll('.procedure__checkbox');
    checkBox.forEach(i => {
        const procedure = procedures.find(
            (p) => p.id === parseInt(i.getAttribute('data-procedure-id'))
        );
        const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);
        if (filterAddOns?.length > 0) {
            i.insertAdjacentHTML(
                'beforeend',
                `
            <span class="checkbox__count" data-procedure-id="${procedure.id}">0</span>
            <span class="checkbox__dots">...</span></div>
            `
            );
        }
    });
}

export function procedureDuration(durations) {
    if (!durations) return '';

    const durationTime = moment.duration(durations, 'm');
    return `${durationTime.hours() ? `${durationTime.hours()}h` : ''} ${durationTime.minutes()}min`;
}
